export default __webpack_public_path__ + "static/media/KAAN05.1180dd7c.png";